<template>
  <div class="text-sm">
    <img
      :src="$asset('img/cancellation/guaranteed-blue-240x240.png')"
      :alt="$t('messages_nl.partials.guarantee.banner.altImage', {companyName})"
      :title="$t('messages_nl.partials.guarantee.banner.altImage', {companyName})"
      width="120"
      height="120"
      class="absolute hidden md:block -left-2 -top-10 z-20 -rotate-12 cursor-pointer drop-shadow-lg border-1 border-dark-grey rounded-full"
      loading="lazy"
    >
    <div class="disable-preflight">
      <i18n-t
        keypath="messages_nl.partials.guarantee.modal.text"
        tag="p"
        scope="global"
      >
        <template v-slot:benefits>
          <ul class="clean my-6">
            <li class="flex items-center my-2">
              <img
                :src="$asset('img/common/checkmark.svg')"
                :alt="$t('messages_nl.images.checkmark')"
                class="mr-2"
                width="30"
                height="30"
                loading="lazy"
              >
              {{ $t('messages_nl.partials.guarantee.modal.benefits.1') }}
            </li>
            <li class="flex items-center my-2">
              <img
                :src="$asset('img/common/checkmark.svg')"
                :alt="$t('messages_nl.images.checkmark')"
                class="mr-2"
                width="30"
                height="30"
                loading="lazy"
              >
              {{ $t('messages_nl.partials.guarantee.modal.benefits.2') }}
            </li>
            <li class="flex items-center my-2">
              <img
                :src="$asset('img/common/checkmark.svg')"
                :alt="$t('messages_nl.images.checkmark')"
                class="mr-2"
                width="30"
                height="30"
                loading="lazy"
              >
              {{ $t('messages_nl.partials.guarantee.modal.benefits.3') }}
            </li>
          </ul>
        </template>
        <template v-slot:contact>
          <a
            :href="$path('contact')"
            target="_blank"
          >
            {{ $t('messages_nl.partials.guarantee.modal._link') }}
          </a>
        </template>
      </i18n-t>
    </div>
  </div>
</template>

<script>
export default {
  name: "adivare-guaranteed-modal",
  props: {
    companyName: {
      type: String,
      required: true,
    }
  }
}
</script>
